<template>
  <div v-if="isAuthenticated">
    <!-- <v-app-bar
      class="custom-app-bar"
      app
      flat
      fixed
      height="75"
      color="primary"
      :src="$vuetify.theme.dark ? imageDark : imageDefault"
    > -->
    <v-app-bar
      :v-text="title"
      id="app-bar"
      app
      flat
      fixed
      height="75"
      color="#FFFF"
    >
      <!-- Drawer -->
      <v-app-bar-nav-icon @click="setDrawer(!drawer)" class="mr-3" />

      <!-- Left section: Logo + Title -->
      <div class="d-flex align-center">
        <!-- <v-img v-if="!drawer"
          src="../../../../assets/final-Logo.png"
          height="55"
          width="55"
          class="rounded-lg mr-3"
          contain
        /> -->
        <!-- <v-img v-if="!drawer"
          height="55"
          width="55"
          src="../../../../assets/final-Logo.png" 
        ></v-img> -->
        <v-img v-if="!drawer"
          height="55"
          width="55"
          src="../../../../assets/logo.png" 
        ></v-img>
        <div class="font-weight-bold text-h6 primary--text">
          {{ title }}
        </div>
      </div>

      <v-spacer />

      <!-- Language Picker -->
      <languagePicker @selectLanguageEvent="selectLanguage" />

      <!-- User Section -->
      <v-menu offset-y rounded="lg">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="ml-4 px-2">
            <div class="d-flex align-center">
              <v-avatar size="40" class="grey lighten-4 mr-2">
                <img v-if="isUserPicture" :src="profileImage" alt="User" />
              </v-avatar>

              <div class="text-left">
                <div class="subtitle-2 grey--text">User</div>
                <div class="font-weight-medium">{{ userID }}</div>
              </div>

              <v-idle
                @idle="onidle"
                @remind="onremind"
                :loop="true"
                :wait="5"
                :duration="webTimeout"
                :hasMultipleTabs="true"
                id="v-idle-timer"
                class="ml-2"
              />
            </div>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="account">
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('profile') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="logout">
            <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import languagePicker from 'components/navigation/languagePicker.vue'

  // Utilities
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import { AUTH_LOGOUT } from 'actions/auth'
  import { expireTimeTextJwt, toggleFullScreen } from '@/utils'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      languagePicker,
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        'You\'re now friends with Andrew',
        'Another Notification',
        'Another one',
      ],
      title: '',
    }),

    computed: {
      ...mapState(['drawer']),
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.first_name} ${state.user.profile.last_name}`,
        userID: state => `${state.user.profile.user_id}`,
        picture_base64: state => `${state.user.profile.picture_base64}`,
        token: state => `${state.auth.token}`,
        webTimeout: state => state.user.profile.webTimeout,
      }),
      tokenExpire: function () {
        return expireTimeTextJwt(this.token)
      },
      isUserPicture () {
        // this.getMenu(this.$i18n.locale)
        return this.picture_base64 !== 'null'
      },
      profileImage () {
        return `data:image/png;base64, ${this.picture_base64}`
      },
      remoteID: {
        get () {
          return this.$store.state.remoteID
        },
      },
      connectDatetime: {
        get () {
          return this.$store.state.connectDatetime
        },
      },
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      selectLanguage (value) {
        this.$emit('selectLanguageEvent', value)
      },
      onidle () {
        // alert('You have been logged out')
        this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
      },
      onremind (time) {
        // alert seconds remaining to 00:00
        // alert(time)
        this.$vToastify.warning(`logout in ${time} seconds`)
      },
      account () {
        this.$router.push('/account')
      },
      logout: function () {
        this.$swal({
          text: 'คุณต้องการที่จะ logout?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่ใช่'
        }).then((result) => {
          if (result) {
            this.logoutaction()
            this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
          }
        })
      },
      logoutaction () {
        this.axios.post(process.env.VUE_APP_API + '/api/v1/auth/logout', {
          user_id: '',
        })
          .then(response => {
            if (!response.data.isSuccess) {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      getWindowTitle (winName) {
        var component = this.$router.options.routes[2].children.find(function (x) {
          return (x.name === winName)
        })
        if (component !== undefined && component !== null) {
          if (component.title !== undefined && component.title !== null) {
            return component.title
          } else {
            return ''
          }
        } else {
          return ''
        }
      },
      setWindowTitle (text) {
        this.$refs.toolbarTitle.innerText = text
      },
    },
  }
</script>
<style scoped>
.v-app-bar {
  backdrop-filter: blur(10px);
}

.primary--text {
  color: #0077c8 !important; /* สี Healthcare ฟ้าอ่อน */
}
.custom-app-bar {
  box-shadow: 0px 1px 3px rgba(0,0,0,0.12) !important;
}
</style>
